import i18n from '../VueI18n'

/**
 *
 * @param {Object} plantio Plantio que deve ser validado
 * @param {Array<Object>} plantios Lista de plantios que devem ser usados para validacao
 */
const validarPlantio = (plantio, plantios) => {
	if (!isUnique(plantio, plantios)) {
		return {
			isValid: false,
			message: `${i18n.t('oCodigo')} "${plantio.ptio_cd_codigo}" ${i18n.t('utilizeUmCodigoDiferenteTalhao')}`,
		}
	}
	return { isValid: true }
}

/**
 * Valida se o plantio possui valores unicos considerando:
 * - ptio_cd_codigo
 * - fk_tlho_talhao
 * @param {Object} plantio Plantio que deve ser validado
 * @param {Array<Object>} plantios Lista de plantios que devem ser usados para validacao
 */
function isUnique(plantio, plantios) {
	return (
		plantios
			.filter((plantioDaLista) => plantioDaLista.fk_tlho_talhao === plantio.fk_tlho_talhao)
			.filter((plantioDaLista) => plantioDaLista.ptio_cd_codigo === plantio.ptio_cd_codigo)
			.length === 0
	)
}

export default validarPlantio
